<template>
  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">Catégorie de marché</h1>
    </div>
    <MarketCategoryForm editMode />
  </div>
</template>

<script>
  import MarketCategoryForm from './MarketCategoryForm.vue';

  export default {
    name: 'MarketCategoryEdit',
    components: { MarketCategoryForm },
  };
</script>
